import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ZapIcon, FileTextIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function WhatYouGet() {
  return <section className="bg-light py-20 md:py-32 px-5" data-id="element-353">
      <div className="max-w-2xl mx-auto" data-id="element-354">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-355">
          <div className="inline-flex items-center gap-2 text-xs font-display font-bold tracking-[0.15em] uppercase text-money-deep border border-money-deep/20 bg-money/5 rounded-full px-4 py-1.5 mb-5" data-id="element-356">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-357" />
            PDF Práctico
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-dark leading-tight" data-id="element-358">
            Lo que <span className="text-gradient-money" data-id="element-359">recibes</span>
          </h2>
          <p className="font-sans text-dark/40 mt-3 text-sm" data-id="element-360">
            Todo esto por menos de lo que gastas en un berrinche en Target 🎯
          </p>
        </motion.div>

        {/* Book content */}
        <motion.div className="space-y-3 mb-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-361">
          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-362">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-363">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-364" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-365">
              <strong data-id="element-366">Configuración en 30 minutos</strong> — materiales, reglas
              y montos sugeridos por edad (5–7, 8–10, 11–14).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-367">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-368">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-369" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-370">
              <strong data-id="element-371">3 opciones de reparto</strong> listas para elegir
              (50/40/10, 40/50/10, 60/30/10).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-372">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-373">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-374" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-375">
              <strong data-id="element-376">Guion palabra por palabra</strong> de la Reunión de 7
              Minutos (cópialo tal cual).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-377">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-378">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-379" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-380">
              Capítulos dedicados a cada jarra: <strong data-id="element-381">Gastar</strong> (lista
              de espera 48h), <strong data-id="element-382">Ahorrar</strong> (metas por edad +
              matching), <strong data-id="element-383">Dar</strong> (valores en acción).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-384">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-385">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-386" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-387">
              <strong data-id="element-388">Protocolo anti-berrinche</strong> para tienda y Amazon (3
              frases + regla Wishlist).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-389">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-390">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-391" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-392">
              <strong data-id="element-393">Consecuencias calmadas</strong> — qué hacer cuando rompen
              reglas (sin gritos, sin culpa).
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-394">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-395">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-396" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-397">
              <strong data-id="element-398">Plan de 30 días</strong> semana por semana con metas
              claras.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-399">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-400">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-401" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-402">
              <strong data-id="element-403">Guía para subir de nivel</strong> — dinero ganado, chores
              y negociación sana.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl p-5 flex items-start gap-4 shadow-sm" data-id="element-404">
            <div className="flex-shrink-0 w-7 h-7 rounded-full bg-money/10 flex items-center justify-center mt-0.5" data-id="element-405">
              <CheckIcon className="w-4 h-4 text-money" data-id="element-406" />
            </div>
            <p className="font-sans text-dark leading-relaxed" data-id="element-407">
              <strong data-id="element-408">Plan de mantenimiento a 12 meses</strong> — cómo hacerlo
              "lo normal" en tu casa.
            </p>
          </motion.div>
        </motion.div>

        {/* Plantillas section */}
        <motion.div className="bg-money/5 border border-money/15 rounded-2xl p-6 md:p-8 mb-8" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-40px'
      }} data-id="element-409">
          <div className="flex items-center gap-3 mb-4" data-id="element-410">
            <div className="w-8 h-8 rounded-full bg-money/15 flex items-center justify-center" data-id="element-411">
              <FileTextIcon className="w-4 h-4 text-money" data-id="element-412" />
            </div>
            <h3 className="font-display text-lg font-bold text-dark" data-id="element-413">
              + Plantillas Incluidas
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-sans text-sm text-dark/70" data-id="element-414">
            <span data-id="element-415">📋 Poster "Reglas de dinero en esta casa"</span>
            <span data-id="element-416">⏳ Lista de espera 48h (con campos listos)</span>
            <span data-id="element-417">📝 Guion completo de la reunión semanal</span>
            <span data-id="element-418">🎯 Tablas de metas y montos por edad</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div className="text-center mt-10" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true
      }} data-id="element-419">
          <a href="#precio" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-bold text-base px-8 py-3.5 rounded-xl shadow-lg hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money" data-id="element-420">
            Obtener Todo Esto →
          </a>
        </motion.div>
      </div>
    </section>;
}